<template>
    <div v-if="loaded">
        <div v-cloak class="caseStudiesWrapwx">
 
            <div class="caseStudiesTypesWrap" v-if="false">
                <div class="caseStudiesTypes">
                    <div class="caseStudiesType" v-for="(type, key) in types" :class="(selected_type == key) ? 'active' : ''" @click="changeType(key)">
                        {{type}}s
                    </div>
                </div>
            </div>

            <div class="caseStudiesCategoriesWrap" v-if="selected_type == 'product'">
                <div class="caseStudiesCategories">
                    <div class="caseStudiesCategory" :class="(selected_category == null) ? 'active' : ''" @click="changeCategory(null)">
                        <span>All</span>
                    </div>
                    <div class="caseStudiesCategory" v-for="(category, key) in categories" :class="(selected_category == key) ? 'active' : ''" @click="changeCategory(key)">
                        <span>{{category}}</span>
                    </div>
                </div>
            </div>
            <div class="caseStudiesCategoriesWrap" v-else>
                <div class="caseStudiesCategories">
                    <div class="caseStudiesCategory" :class="(selected_solution == null) ? 'active' : ''" @click="changeSolution(null)">
                        <span>All</span>
                    </div>
                    <div class="caseStudiesCategory" v-for="(solution, key) in solutions" :class="(selected_solution == key) ? 'active' : ''" @click="changeSolution(key)">
                        <span>{{solution}}</span>
                    </div>
                </div>
            </div>

            <div class="caseStudiesMobile">
                <div class="selectWrap">
                    <select @change="changeCategory(selected_category)" v-model="selected_category">
                        <option :value="null">All</option>
                        <option v-for="(category, key) in categories" :value="key">{{category}}</option>
                    </select>
                </div>
            </div>

            <div class="caseStudiesBody swiperLight">
                <div v-if="loading" class="loader">
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
                <div class="slideGrid" v-else-if="case_studies.length > 0">
                    <a class="gridItem" v-for="case_study in case_studies" :href="case_study.url">
                        <div class="itemImage" 
                            v-if="case_study.fields.grid_image.sizes && case_study.fields.grid_image.sizes['grid-image']"
                            :style='{ backgroundImage: "url(" + case_study.fields.grid_image.sizes["grid-image"] + ")" }'
                        ></div>
                        <div class="itemMain">
                            <div class="itemMainInner">
                                <h3>{{case_study.data.post_title}}</h3>
                                <p>More</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="noCaseStudies" v-else>
                    No case studies found
                </div>
            </div>

        </div>
    </div>
    <div v-else class="loader">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div>
</template>

<script>
export default {
    props: [
        'categories',
        'types',
        'solutions',
        'default_type',
        'default_category',
        'default_solution'
    ],
    data() {
        return {
            loaded: false,
            loading: false,
            case_studies: [],
            selected_type: Object.keys(this.types)[0],
            selected_category: null,
            selected_solution: null
        };
    },
    mounted() {
        this.boot();
    },
    methods: {
        boot(){
            if(this.default_type != null){
                this.selected_type = this.default_type;
            }

            if(this.default_category != null){
                this.selected_category = this.default_category;
            }

            if(this.default_solution != null){
                this.selected_solution = this.default_solution;
            }

            this.update();
        },
        changeType(key) {
            this.selected_type = key;
            this.selected_category = null;
            this.selected_solution = null;
            this.update();
        },
        changeCategory(key) {
            this.selected_category = key;
            this.update();
        },
        changeSolution(key) {
            this.selected_solution = key;
            this.update();
        },
        update() {
            var vue_instance = this;
            this.loading = true;

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    'action':'load_case_studies',
                    'type' : this.selected_type,
                    'category' : this.selected_category,
                    'solution' : this.selected_solution
                },
                success:function(data) {
                    var response = jQuery.parseJSON(data);
                    vue_instance.case_studies = response.case_studies;
                    vue_instance.loaded = true;
                    vue_instance.loading = false;
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
        }
    }
}
</script>
